const statuses = {
  notSubscribed: 'not_subscribed',
  active: 'active',
  onHold: 'on_hold',
  waitingProlong: 'waiting_prolong',
  unpaid: 'unpaid',
  pending: 'pending',
  cancelled: 'cancelled',
  notAuthorized: 'not_authorized',
  paused: 'paused',
  undeliverable: 'undeliverable',
  pendingUpgrade: 'pending_upgrade',
  pendingChangePlan: 'pending_change_plan',
} as const


export type SubscriptionStatus = keyof typeof statuses

export default statuses
